import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef
} 
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { BehaviorSubject, ReplaySubject } from 'rxjs';
//Service
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { HHModel } from '../de-nghi-mua-hang-model/de-nghi-mua-hang.model';
import { DeNghiMuaHangService } from '../de-nghi-mua-hang-service/de-nghi-mua-hang.service';

@Component({
	selector: 'm-add-hang-hoa-dialog',
	templateUrl: './add-hang-hoa-dialog.component.html',
	styleUrls: ['../de-nghi-mua-hang.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class AddHangHoaComponent implements OnInit{
    /*Config Form */
    CONFIG: CommonConFig;

    /* Loading.... */
    loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();
    /* ------------------------------------------------------------------ */

    /* Extend field:  */
    title: string = '';					// Tiêu đề dialog
    viewLoading: boolean = false;   	// Loading khi mở dialog
    _result: HHModel;
    /* ------------------------------------------------------------------ */
    
    /* Các Sub form trên dialog:  */
    HHForm: FormGroup;				     
    /* ------------------------------------------------------------------ */

    /* Mat select search cho DVT */
    listDVT : any[] = [];
	selectDVT : string = '';
	filteredDVT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	DVTFilterCtrl: string = '';
    /* ------------------------------------------------------------------ */

    /* Mat select search cho Loại hàng */
    listLoaiHH : any[] = [];
	selectLoaiHH : string = '';
	filteredLoaiHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	LoaiHHFilterCtrl: string = '';
    /* ------------------------------------------------------------------ */

    /* Mat select search cho Nhóm hàng */
    listNhomHH : any[] = [];
	selectNhomHH : string = '';
	filteredNhomHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	NhomHHFilterCtrl: string = '';
    /* ------------------------------------------------------------------ */

    constructor(
        public dialogRef: MatDialogRef<AddHangHoaComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dungChungService: DungChungService,
        private deNghiMuaHangService: DeNghiMuaHangService,
		private HHFB: FormBuilder,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
    ) { 
		this.dialogRef.disableClose = true;
    }

    /*---------------------------- LOAD DATA --------------------------------*/
    ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
        
		/*Load title of dialog */
        this.title = this.getTitle();
        this.ListDVT();
        this.ListLoaiHH();

		/*create form */
		this.createForm();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back(0);
			}
			this.changeDetectView();
		});

    }
    /* -----------------------------------------------------------------------*/


    /*----------------- Create Form with appropriate sub forms ---------------*/
    createForm(){
		/*Group các Form */
		this.HHForm = this.HHFB.group({
            MaHH: ['', Validators.required],
            TenHH: ['', Validators.required],
            DVT: ['', Validators.required],
            LoaiHH: ['', Validators.required],
            NhomHH: ['', Validators.required],
        });
        
    }
    getTitle(): string {
		return `THÊM NHANH MẶT HÀNG`;
    }
    /* -----------------------------------------------------------------------*/


    /*-------------------------- Các hàm lấy danh sách -----------------------*/
    ListDVT(){
		this.dungChungService.listDVT().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDVT = res.data;
				this.filteredDVT.next(this.listDVT.slice());
				this.changeDetectView();
			};
		});
	}
	filterListDVT() {
		if (!this.listDVT) {
			return;
		}
		let search = this.DVTFilterCtrl;
		if (!search) {
			this.filteredDVT.next(this.listDVT.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredDVT.next(
			this.listDVT.filter(ts =>
				ts.TenDVT.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
    }
    
    ListLoaiHH(){
		this.dungChungService.listLoaiHH().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listLoaiHH = res.data;
				this.filteredLoaiHH.next(this.listLoaiHH.slice());
				this.changeDetectView();
			};
		});
	}
	filterListLoaiHH() {
		if (!this.listLoaiHH) {
			return;
		}
		let search = this.LoaiHHFilterCtrl;
		if (!search) {
			this.filteredLoaiHH.next(this.listLoaiHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredLoaiHH.next(
			this.listLoaiHH.filter(ts =>
				ts.TenLoaiHH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
    }
    
    ListNhomHHTheoLoai(IdLoai: number){
		this.dungChungService.listNhomHHTheoLoai(IdLoai).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listNhomHH = res.data;
				this.filteredNhomHH.next(this.listNhomHH.slice());
				this.changeDetectView();
			};
		});
	}
	filterListNhomHH() {
		if (!this.listNhomHH) {
			return;
		}
		let search = this.NhomHHFilterCtrl;
		if (!search) {
			this.filteredNhomHH.next(this.listNhomHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredNhomHH.next(
			this.listNhomHH.filter(ts =>
				ts.Tennhomhh.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
    /* -----------------------------------------------------------------------*/

    /*---------------------------- Thao tác trên form ------------------------*/
    changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
    back(type: number){
		this.dialogRef.close({ 
                data: type == 0 ? null : this._result
		});
    }
    onSubmit(){
        if (this.HHForm.invalid) {
            Object.keys(this.HHForm.controls).forEach(controlName =>
                this.HHForm.controls[controlName].markAsTouched()
            );
            return false;
        }

        this._result = new HHModel();
        this._result.clear();
        this._result.MaHH = this.HHForm.controls["MaHH"].value;
        this._result.TenHH = this.HHForm.controls["TenHH"].value;
        this._result.DVT1 = +this.HHForm.controls["DVT"].value;
		this._result.Id_NhomHH = +this.HHForm.controls["NhomHH"].value;
		
		this.listDVT.forEach(element =>{
			if(element.Id_DVT == this._result.DVT1){
				this._result.TenDVT = element.TenDVT
			}
		})

        this.deNghiMuaHangService.addHH(this._result).subscribe(res => {
            if (res.status == 1){
				this._result.Id_HH = res.data.Id_HH
                const message = `Hàng hóa mới đã được thêm`;
                this.layoutUtilsService.showInfo(message);
                this.back(1);
            }
            else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
        });
    }
    /* -----------------------------------------------------------------------*/
}